export const dashReplacerHook = (sourceStr: string): string => {
    let sourceSentence = sourceStr
    sourceSentence = sourceSentence.replace(/[\s]-[\s]/g, ' — ')
    return sourceSentence
}
